function EventFieldPreview({ label, name, type, attributes, options = [] }) {
	switch (type) {
		case "short_text":
			return (
				<div>
					<label>{label}</label>
					<div>
						<input type="text" name={name} placeholder={attributes.placeholder} />
					</div>
				</div>
			);

		case "long_text":
			return (
				<div>
					<label>{label}</label>
					<div>
						<textarea name={name} placeholder={attributes.placeholder}></textarea>
					</div>
				</div>
			);

		case "number":
			return (
				<div>
					<label>{label}</label>
					<div>
						<input type="number" name={name} />
					</div>
				</div>
			);

		case "select":
			return (
				<div>
					<label>{label}</label>
					<div>
						<select name={name}>
							{options.map((opt, idx) => (
								<option key={idx}>{opt}</option>
							))}
						</select>
					</div>
				</div>
			);

		case "multi_select":
			return (
				<div>
					<label>{label}</label>
					<div>
						<select name={name} multiple>
							{options.map((opt) => (
								<option key={opt}>{opt}</option>
							))}
						</select>
					</div>
				</div>
			);

		case "checkbox":
			return (
				<div>
					<label>{label}</label>
					<div>
						{options.map((opt, idx) => (
							<label key={idx}>
								<input type="checkbox" name={name} value={opt} /> {opt}
							</label>
						))}
					</div>
				</div>
			);

		case "radio":
			return (
				<div>
					<label>{label}</label>
					<div>
						{options.map((opt, idx) => (
							<label key={idx}>
								<input type="radio" name={name} value={opt} /> {opt}
							</label>
						))}
					</div>
				</div>
			);

		case "date":
			return (
				<div>
					<label>{label}</label>
					<div>
						<input type="date" name={name} />
					</div>
				</div>
			);

		case "file":
			return (
				<div>
					<label>{label}</label>
					<div>
						<input type="file" name={name} />
					</div>
				</div>
			);

		case "custom":
			return (
				<div>
					<label>{label}</label>
					<div>
						<input type="text" name={name} placeholder="Custom field" />
					</div>
				</div>
			);

		default:
			return null;
	}
}

export default EventFieldPreview;
